import { CommandType, URLS } from '~/constants';
import { isEmpty } from 'lodash';
import { equals, propSatisfies } from 'ramda';

export const getIconUrl = ({ id, iconAttachId }) => {
  return !isEmpty(iconAttachId) && iconAttachId !== '0'
    ? `${URLS.API}/apps/${id}/icon/${iconAttachId}`
    : URLS.DEFAULT_BOT_IMAGE;
};

const isValidIcon = (iconAttachId) => {
  return iconAttachId !== '0' && !!iconAttachId;
};

export const isDefaultCommand = propSatisfies(equals(CommandType.Default), 'type');

const integrationAppUtil = {
  isValidIcon,
};
export default integrationAppUtil;
